import { create } from "zustand";

const useTagsStore = create((set) => ({
  tags: [],
  loading: false,

  setTags: (tags) => set({ tags }),
  setLoading: (loading) => set({ loading }),
}));

export default useTagsStore;
